package org.example.zone360.pages.coachDetails.sessionAllDetails.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaPause
import com.varabyte.kobweb.silk.components.icons.fa.FaPlay
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.DraggableRangeSlider
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.VideoProgressSliderCustom1
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSentencesData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.pages.players_Details.videosSection.encodeFileName
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Video
import org.w3c.dom.Audio
import org.w3c.dom.HTMLVideoElement
import kotlin.math.min

@Composable
fun VideoSectionUI(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    sessionData: GetSessionsData,
    isVideoDurationPlaying1: Boolean,
    isVideoDurationPlaying1CallBack: (Boolean) -> Unit,
    isPlayingAll: Boolean,
    scope: CoroutineScope,
    fullSessionVideoCallBack: (Boolean) -> Unit,
    stopPaginationSizeCallBack: (Boolean) -> Unit,
    useOriginalAudio: Boolean,
    currentlyPlayingVideoIdCallBack: (String?) -> Unit,
    currentVideoRef1: MutableState<HTMLVideoElement?>,
    isCustomHighlight : Boolean,
    sliderStartTime: Double,
    sliderStartTimeCallBack: (Double) -> Unit,
    sliderEndTime: Double,
    sliderEndTimeCallBack: (Double) -> Unit,
    seekWhenPaused: Double?,
    seekWhenPausedCallBack: (Double?) -> Unit,
    highlightSegments: List<Pair<Float, Float>>,
    highlightSegmentsCallback: (List<Pair<Float, Float>>) -> Unit,
    getSentenceAudio: Audio?,
    currentAudioRefHighlight1: MutableState<Audio?>,
    playVideoWithAudioFun: ( HTMLVideoElement,Audio?) -> Unit,
    currentVideoTimeCallBack: (Double) -> Unit,
    currentVideoTime: Double,
    isBuffering1 : Boolean,
    videoProgress1: Float,
    videoProgressCallBack: (Float) -> Unit,
    allowProgressUpdateCallBack: (Boolean) -> Unit,
    manualSeekTriggeredCallBack: (Boolean) -> Unit,
    selectedKeyword: String?,
    getSentences: List<GetSentencesData>,
    selectedName : String?,
    sessionDuration: Double,
    currentAudioRefHighlight: MutableState<Audio?>,

    ){

    var isHovered1 by remember { mutableStateOf(false) }
    val sessionId1 = sessionData.sessionId
    val fileName = sessionData.videoFile
    val encodedFileName = encodeFileName(fileName)
    val sessionVideo = "${Res.Video.base_Video_URL}$encodedFileName"


    fun refreshHighlightSegmentsAfterVideoReady() {
        highlightSegmentsCallback(getSentences
            .filter { sentence ->
                selectedKeyword?.let { keyword ->
                    sentence.keywords?.any {
                        it.text.equals(
                            keyword,
                            ignoreCase = true
                        )
                    } == true
                } ?: !sentence.keywords.isNullOrEmpty() // 🛑 Only valid if it has keywords
            }
            .map { sentence -> sentence.startTime.toFloat() to sentence.endTime.toFloat() }
            .distinct() // 💡 Optional: remove duplicates
            .sortedBy { it.first }
        )

        debugPrintln("🔄 Highlight segments refreshed after video ready. Size: ${highlightSegments.size}")
    }

    val modifier: Modifier =
        if (breakpoint >= Breakpoint.XL) Modifier.height(400.px) else Modifier
    Box(
        modifier = modifier.fillMaxWidth()
            .margin(topBottom = 10.px)
            .onMouseEnter { isHovered1 = true }
            .onMouseLeave { isHovered1 = false },
        contentAlignment = Alignment.Center
    ) {
        if (!isVideoDurationPlaying1 && !isPlayingAll) {

            Box(
                modifier = Modifier.size(if (breakpoint < Breakpoint.MD) 40.px else 54.px)
                    .zIndex(9)
                    .borderRadius(100.percent)
                    .backgroundColor(sitePalette.primary.rgb)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        scope.launch {
                            val videoElement =
                                document.getElementById("video_$sessionId1") as? HTMLVideoElement
                            if ((videoElement?.readyState
                                    ?: 0) < 1
                            ) return@launch

                            fullSessionVideoCallBack(true)
                            stopPaginationSizeCallBack(true)

                            videoElement!!.muted =
                                !useOriginalAudio

                            currentlyPlayingVideoIdCallBack(sessionId1)
                            currentVideoRef1.value =
                                videoElement

                            if (isCustomHighlight && sliderStartTime < sliderEndTime) {
                                val start =
                                    sliderStartTime.coerceIn(
                                        0.0,
                                        videoElement.duration
                                    )
                                val end =
                                    sliderEndTime.coerceIn(
                                        start + 0.1,
                                        videoElement.duration
                                    )
                                seekWhenPausedCallBack(start)
                                highlightSegmentsCallback(listOf(start.toFloat() to end.toFloat()))

                                if (useOriginalAudio) {
                                    videoElement.currentTime =
                                        start
                                    videoElement.play()
                                        .catch {
                                            debugPrintln(" Error playing original video: ${it.message}")
                                        }
                                } else {
                                    getSentenceAudio?.currentTime =
                                        start
                                    currentAudioRefHighlight1.value =
                                        getSentenceAudio
                                    playVideoWithAudioFun(
                                        videoElement,
                                        getSentenceAudio
                                    )
                                }
                            } else {
                                // ▶️ Default Behavior
                                if (useOriginalAudio) {
                                    videoElement.currentTime =
                                        seekWhenPaused
                                            ?: 0.0
                                    videoElement.play()
                                        .catch {
                                            debugPrintln(" Error playing video with original audio: ${it.message}")
                                        }
                                    videoElement.ontimeupdate =
                                        {
                                            val currentTime =
                                                videoElement.currentTime

                                            currentVideoTimeCallBack(currentTime)
                                        }
                                } else {
                                    getSentenceAudio?.let { audio ->
                                        val seekTimeSnapshot =
                                            seekWhenPaused
                                        if (seekTimeSnapshot != null) {
                                            videoElement.currentTime =
                                                seekTimeSnapshot
                                            audio.currentTime =
                                                seekTimeSnapshot
                                            seekWhenPausedCallBack(null)
                                        } else {
                                            videoElement.currentTime =
                                                0.0
                                            audio.currentTime =
                                                0.0
                                        }

                                        currentAudioRefHighlight1.value =
                                            audio
                                        playVideoWithAudioFun(
                                            videoElement,
                                            audio
                                        )
                                    }
                                }
                            }
                        }
                    },
                contentAlignment = Alignment.Center
            ) {
                FaPlay(
                    size = if (breakpoint < Breakpoint.MD) IconSize.X1 else IconSize.XL,
                    modifier = Modifier.color(Colors.White)
                        .margin(top = 1.8.px, left = 2.px)
                )
            }
        } else {
            if ((isHovered1 || isBuffering1) && !isPlayingAll) {
                Box(
                    modifier = Modifier.size(if (breakpoint < Breakpoint.MD) 40.px else 54.px)
                        .zIndex(9)
                        .borderRadius(100.percent)
                        .backgroundColor(sitePalette.primary.rgb)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            fullSessionVideoCallBack(false)
                            stopPaginationSizeCallBack(false)

                            currentVideoTimeCallBack(0.0)
                            val videoElement =
                                document.getElementById("video_$sessionId1") as? HTMLVideoElement
                            val audioElement =
                                currentAudioRefHighlight.value

                            videoElement?.let {
                                isVideoDurationPlaying1CallBack(false)
                                // Create a local safe pause function for this specific click handler
                                val safelyPauseMedia = {
                                    // Get the current play state
                                    val isVideoPlaying =
                                        !it.paused && !it.ended && it.readyState > 2
                                    val isAudioPlaying =
                                        audioElement?.let { audio -> !audio.paused && !audio.ended }
                                            ?: false

                                    // Only attempt to pause if the media is actually playing
                                    if (isVideoPlaying) {
                                        it.pause()
                                    }

                                    if (isAudioPlaying) {
                                        audioElement!!.pause()
                                    }
                                }

                                // Use the safe pause function
                                safelyPauseMedia()
                                currentlyPlayingVideoIdCallBack(null)
                                currentVideoRef1.value =
                                    null
                                currentAudioRefHighlight.value =
                                    null
                            }
                        },

                    contentAlignment = Alignment.Center
                ) {
                    if (isBuffering1) {
                        Box(modifier = Modifier.onClick {
                        }) {
                            ProgressIndicator()
                        }
                    } else {
                        FaPause(
                            size = if (breakpoint < Breakpoint.MD) IconSize.X1 else IconSize.XL,
                            modifier = Modifier.color(Colors.White)
                                .margin(top = 1.px)
                        )
                    }
                }
            }
        }

        Box(modifier = Modifier.fillMaxSize()) {

            val highlightSegments1 = remember(
                highlightSegments,
                currentAudioRefHighlight1.value,
                useOriginalAudio
            ) {
                val videoElement =
                    document.getElementById("video_$sessionId1") as? HTMLVideoElement
                val videoDuration =
                    videoElement?.duration ?: 0.0
                val audioDuration =
                    (sessionData.recordTime.toDoubleOrNull()
                        ?: 0.0) / 1000.0

                val maxDuration =
                    maxOf(videoDuration, audioDuration)

                // 🛑 Skip rendering if video duration is not ready yet
                if (maxDuration == 0.0 || maxDuration.isNaN()) return@remember emptyList()

                highlightSegments.mapNotNull { (startTime, endTime) ->
                    val safeStart = startTime.coerceIn(
                        0f,
                        maxDuration.toFloat()
                    )
                    val safeEnd = endTime.coerceIn(
                        0f,
                        maxDuration.toFloat()
                    )
                    if (safeStart >= safeEnd) return@mapNotNull null

                    val startProgress =
                        safeStart / maxDuration.toFloat()
                    val endProgress =
                        safeEnd / maxDuration.toFloat()
                    Triple(
                        startProgress,
                        endProgress,
                        "#FF5722"
                    )
                }
            }

            Box(
                modifier = Modifier.fillMaxWidth(97.percent)
                    .padding(leftRight = 10.px)
                    .align(Alignment.BottomCenter)
                    .zIndex(99)
                    .margin(bottom = if (breakpoint <= Breakpoint.MD) 6.px else 40.px),
                contentAlignment = Alignment.TopCenter
            )
            {

                Column(Modifier.fillMaxWidth().gap(if (breakpoint < Breakpoint.MD) 3.px else 10.px)) {
                    val videoElement =
                        document.getElementById("video_$sessionId1") as? HTMLVideoElement
                    if (videoElement != null) {

                        if (isVideoDurationPlaying1) {
                            VideoProgressSliderCustom1(

                                modifier = Modifier.fillMaxWidth()
                                    .height(5.px)
                                    .zIndex(9),
                                progress = videoProgress1,
                                timeSegments = highlightSegments1,
                                isThumbMove = selectedKeyword == null && selectedName == null && !isCustomHighlight,
                                onProgressChange = { newProgress ->

                                    manualSeekTriggeredCallBack(true)
                                    val htmlVideoElement =
                                        document.getElementById(
                                            "video_$sessionId1"
                                        ) as? HTMLVideoElement
                                    val audioElement =
                                        currentAudioRefHighlight1.value

                                    val videoDuration =
                                        htmlVideoElement?.duration
                                            ?: 0.0
                                    debugPrintln("🔵 Video duration: $videoDuration")
                                    val audioDuration =
                                        audioElement?.duration
                                            ?: 0.0
                                    debugPrintln("🔵 Audio duration: $audioDuration")
                                    val maxDuration = maxOf(
                                        videoDuration,
                                        audioDuration
                                    )
                                    debugPrintln("🔵 Max duration: $maxDuration")

                                    val seekTime =
                                        newProgress * maxDuration
                                    debugPrintln("🔵 Seekbar clicked at progress: $newProgress, target seekTime: $seekTime sec (maxDuration: $maxDuration sec)")

                                    try {
                                        htmlVideoElement?.pause()
                                        audioElement?.pause()
                                    } catch (e: dynamic) {
                                        console.log(" Pause error: ${e.message}")
                                    }
                                    // Remove any previous handlers to avoid conflicts
                                    htmlVideoElement?.onplaying =
                                        null

                                    htmlVideoElement?.onplaying =
                                        {
                                            // Only seek if not already at the right position (saves cycles)
                                            if (kotlin.math.abs(
                                                    (htmlVideoElement?.currentTime
                                                        ?: 0.0) - seekTime
                                                ) > 0.5
                                            ) {
                                                htmlVideoElement?.currentTime =
                                                    min(
                                                        seekTime,
                                                        videoDuration
                                                    )
                                                debugPrintln(
                                                    "🟢 [onPlaying] Set video.currentTime = ${htmlVideoElement?.currentTime}"
                                                )
                                            } else {
                                                debugPrintln(
                                                    "🟢 [onPlaying] Already at correct time: ${htmlVideoElement?.currentTime}"
                                                )
                                            }
                                            // Remove handler after seeking once
                                            null.also {
                                                htmlVideoElement?.onplaying =
                                                    it
                                            }
                                        }

                                    // Play the video and audio (audio can be set directly)
                                    scope.launch {
                                        delay(100)
                                        try {
                                            htmlVideoElement?.play()
                                                ?.catch {
                                                    console.log(
                                                        " Video play error: ${it.message}"
                                                    )
                                                }
                                            audioElement?.play()
                                                ?.catch {
                                                    console.log(
                                                        " Audio play error: ${it.message}"
                                                    )
                                                }
                                            audioElement?.currentTime =
                                                min(
                                                    seekTime,
                                                    audioDuration
                                                )
                                        } catch (e: dynamic) {
                                            console.log(" Play error: ${e.message}")
                                        }
                                    }

                                    videoProgressCallBack((seekTime / maxDuration).toFloat())
                                    allowProgressUpdateCallBack(false)
                                    window.setTimeout({
                                        try {
                                            allowProgressUpdateCallBack(true)
                                            manualSeekTriggeredCallBack(false)
                                        } catch (e: dynamic) {
                                        }
                                    }, 500)
                                }
                            )
                        } else if (isCustomHighlight) {
                            // This ensures default range only sets once
                            val initializedOnce =
                                remember(sessionId1) {
                                    mutableStateOf(false)
                                }

                            if (!initializedOnce.value && sliderEndTime == 0.0 && sessionDuration > 0.0) {
                                sliderStartTimeCallBack(0.0)

                                sliderEndTimeCallBack(
                                    sessionDuration.coerceAtMost(
                                        30.0
                                    )
                                )// ✅ handles both <30.0 and >30.0
                                initializedOnce.value = true
                            }

                            DraggableRangeSlider(
                                widthPx = 600.0,
                                initialMinPercent = sliderStartTime / sessionDuration,
                                initialMaxPercent = sliderEndTime / sessionDuration,
                                onRangeChange = { minPercent, maxPercent ->
                                    sliderStartTimeCallBack(sessionDuration * minPercent)
                                    sliderEndTimeCallBack(sessionDuration * maxPercent)
                                }
                            )
                        } else if (selectedKeyword != null) {
                            VideoProgressSliderCustom1(

                                modifier = Modifier.fillMaxWidth()
                                    .height(5.px)
                                    .zIndex(9),
                                progress = videoProgress1,
                                isThumbMove = false,
                                onProgressChange = {
                                },
                                timeSegments = highlightSegments1
                            )
                        } else {
                            VideoProgressSliderCustom1(

                                modifier = Modifier.fillMaxWidth()
                                    .height(5.px)
                                    .zIndex(9),
                                progress = videoProgress1,
                                isThumbMove = false,
                                onProgressChange = {

                                },
                                timeSegments = highlightSegments1
                            )
                        }
                        if (!isCustomHighlight && !isPlayingAll && selectedKeyword == null && selectedName == null) {
                            val videoDuration =
                                videoElement.duration
                            val audioDuration =
                                (sessionData.recordTime.toDoubleOrNull()
                                    ?: 0.0) / 1000.0
                            val maxDuration = maxOf(
                                videoDuration,
                                audioDuration
                            )

                            val currentTimeFormatted =
                                currentVideoTime.toLong()
                                    .formatSessionMinutes()
                            val totalTimeFormatted =
                                maxDuration.toLong()
                                    .formatSessionMinutes()

                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                FieldTitleTextNormalSimple(
                                    "$currentTimeFormatted / $totalTimeFormatted",
                                    fontSize = 15.px,
                                    fontWeight = 500
                                )
                            }
                        }
                    }
                }
            }

            LaunchedEffect(sessionId1) {
                val videoElementForMute =
                    document.getElementById("video_$sessionId1") as? HTMLVideoElement

                videoElementForMute?.let { video ->
                    if (video.readyState < 1) {
                        video.onloadedmetadata = {
                            if (!isCustomHighlight && !isPlayingAll && selectedKeyword == null)
                                refreshHighlightSegmentsAfterVideoReady()
                        }
                    } else {
                        if (!isCustomHighlight && !isPlayingAll && selectedKeyword == null)
                            refreshHighlightSegmentsAfterVideoReady()
                    }
                }
            }

            LaunchedEffect(useOriginalAudio) {
                val videoElement =
                    document.getElementById("video_$sessionId1") as? HTMLVideoElement
                videoElement?.muted = !useOriginalAudio
            }

            Video(
                attrs = {
                    attr("id", "video_$sessionId1")
                    attr("src", sessionVideo)
                    attr("preload", "auto")
                    style {
                        property("width", "100%")
                        property("height", "100%")
                        property("border-radius", "8px")
                        property("object-fit", "cover")
                        property("align", "bottom center")
                    }
                }
            )
        }
    }
}